import { type WorkoutSettings } from "@fitness-app/data-models/entities/TraineeSettings";
import { WeightHint } from "@fitness-app/data-models/entities/TrainingProgram";

export interface ResolvedWorkoutHintSettings {
  weightHint: WeightHint;
  /** Already combined with `weightHint` — false whenever the hint itself is off. */
  applyHintToRepeats: boolean;
}

/**
 * Single source of truth for the workout hint defaults. Every surface (mobile, client-web, admin
 * preview, live workout) has to resolve them the same way, otherwise the client sees one repeat
 * count in the workout list and another one inside the exercise — which is exactly what TRE-1824
 * and TRE-1825 reported.
 */
export const getWorkoutHintSettings = (settings?: WorkoutSettings | null): ResolvedWorkoutHintSettings => {
  const weightHint = settings?.weightHint ?? WeightHint.LATEST;

  return {
    weightHint,
    // Off by default: the planned repeat count is the trainer's prescription, so it stays visible
    // until the client explicitly asks for last week's numbers.
    applyHintToRepeats: weightHint !== WeightHint.DEFAULT && (settings?.applyHintToRepeats ?? false),
  };
};
